var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_6430)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7838,
    height: 22,
    rx: 2,
    fill: "#09141E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_895_6430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06531 7.63565L9.77735 8.62776C10.7105 6.45973 12.0684 4.79213 13.4695 4.01385C10.9227 3.88436 8.45453 4.9956 6.86875 6.98088C6.68813 7.20534 6.79438 7.54002 7.06531 7.63565ZM10.5769 8.91596L16.912 11.2234C17.8616 7.99876 17.4066 5.07157 15.7797 4.47923C15.5838 4.4095 15.3781 4.37133 15.1656 4.37133C13.6263 4.37059 11.7589 6.21004 10.5769 8.91596ZM17.8523 5.60919C18.0184 6.04084 18.1379 6.52879 18.2011 7.07677C18.3538 8.40144 18.1646 9.94818 17.6996 11.5101L20.4249 12.5027C20.694 12.6023 20.9894 12.413 20.996 12.1276C21.0611 9.58268 19.8844 7.1469 17.8523 5.60919ZM18.025 15.9019H12.5266L14.2531 11.1605L12.6559 10.5796L10.72 15.9027H5.275C4.57083 15.9019 4 16.473 4 17.1769C4 17.4106 4.19027 17.6019 4.425 17.6019H18.875C19.1097 17.6019 19.3 17.4116 19.3 17.2008C19.3 16.473 18.7289 15.9019 18.025 15.9019Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_6430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7838,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_895_6430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 13.6,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOff);
export default __webpack_public_path__ + "static/media/TimeOff.98648b482cf3cfebe000ffa6a1929653.svg";
export { ForwardRef as ReactComponent };